document.addEventListener("DOMContentLoaded", () => {
  // --- Animate first 2 drawers once ---
  setTimeout(() => {
    const drawers = document.querySelectorAll(".ss-drawer:not(.open)");
    drawers.forEach((drawer) => {
      drawer.classList.add('peek')
    });
    setTimeout(() => {
      const drawers = document.querySelectorAll(".ss-drawer.peek");
      drawers.forEach((drawer) => {
        drawer.classList.remove('peek')
      });
    }, 3000)
  }, 3000);

  // --- Scroll vs. tap guard ---
  let touchStartY = 0;
  let touchMoved = false;

  document.addEventListener("touchstart", (e) => {
    touchStartY = e.touches[0].clientY;
    touchMoved = false;
  });

  document.addEventListener("touchmove", (e) => {
    if (Math.abs(e.touches[0].clientY - touchStartY) > 10) {
      touchMoved = true; // mark as scroll
    }
  });

  // --- Wrapper click logic (open one at a time) ---
  document.addEventListener("click", (event) => {
    if (touchMoved) return; // ignore if it was a scroll

    const wrapper = event.target.closest(".size-selector-wrapper");
    if (!wrapper) return;

    const drawer = wrapper.querySelector(".ss-drawer");
    if (!drawer) return;

    // Close all others
    document.querySelectorAll(".ss-drawer.open").forEach((openDrawer) => {
      if (openDrawer !== drawer) {
        openDrawer.classList.remove("open");
      }
    });

    // Open this one
    drawer.classList.add("open");
  });
});